import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Mail, Rss } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-950 border-t border-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-orange-500 to-orange-600">
                <Truck className="h-6 w-6 text-white" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white leading-tight">TruckAccidentSupport</span>
                <span className="text-xs text-orange-400 leading-tight">Accident & Safety Resources</span>
              </div>
            </Link>
            <p className="text-gray-400 text-sm mb-4 max-w-md">
              Providing practical guidance for truck drivers, fleet owners, and safety managers on accident prevention, driver protection, and legal risk reduction.
            </p>
            <div className="flex flex-col space-y-2 text-sm text-gray-400">
              <a href="mailto:info@truckaccidentsupport.com" className="flex items-center space-x-2 hover:text-orange-400 transition-colors">
                <Mail className="h-4 w-4" />
                <span>info@truckaccidentsupport.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/videos" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Videos
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-orange-400 transition-colors">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/advertise" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Advertise With Us
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-400 hover:text-orange-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <a 
                  href={`${process.env.REACT_APP_BACKEND_URL}/api/rss/feed`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-orange-400 transition-colors flex items-center gap-1"
                >
                  <Rss className="h-3 w-3" />
                  RSS Feed
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} TruckAccidentSupport.com. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs text-center md:text-right max-w-md">
              This website is an educational resource. Information provided is not legal advice. 
              Consult with qualified professionals for specific situations.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
